import styled from "styled-components";
import { BTTO_PROFILE_COLORS, bettoFocusRing } from "../../shared/elements";

export const TabsRoot = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	width: 100%;
	margin-bottom: 16px;

	@media (min-width: 1024px) {
		display: none;
	}
`;

export const TabsLabel = styled.span`
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 12px;
	font-weight: 500;
	line-height: 1.2;
`;

export const TabsRow = styled.div`
	display: flex;
	gap: 8px;
	width: 100%;
`;

export const TabButton = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex: 1;
	min-height: 40px;
	padding: 0 16px;
	border-radius: 8px;
	border: 1px solid
		${({ $active }) =>
			$active ? BTTO_PROFILE_COLORS.borderActive : BTTO_PROFILE_COLORS.border};
	background: ${({ $active }) =>
		$active ? BTTO_PROFILE_COLORS.primary : BTTO_PROFILE_COLORS.surfaceRaised};
	color: ${({ $active }) =>
		$active ? BTTO_PROFILE_COLORS.primaryText : BTTO_PROFILE_COLORS.text};
	font-size: 14px;
	font-weight: 600;
	line-height: 1.2;
	cursor: pointer;
	transition:
		background 0.2s ease,
		border-color 0.2s ease,
		color 0.2s ease;
	${bettoFocusRing}

	&:hover {
		background: ${({ $active }) =>
			$active ? BTTO_PROFILE_COLORS.primaryDark : BTTO_PROFILE_COLORS.surfaceHover};
		color: ${({ $active }) =>
			$active ? BTTO_PROFILE_COLORS.primaryText : BTTO_PROFILE_COLORS.text};
	}
`;
